import App from './App.vue'
import router from './router'
import { antComponents } from './antd'
import { CommonComponents } from './use-common-components'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import { useDirectives } from './directives'
import cookies from 'vue-cookies'
import Chart from 'chart.js/auto'
import 'cesium/Build/Cesium/Widgets/widgets.css'
import 'cesium-navigation-es6/dist/styles/cesium-navigation.css'
import '/@/styles/index.scss'
import svgIcon from './components/svgIcon.vue'
import './permission'
import { initIcons } from './plugins/icons'
import 'swiper/swiper-bundle.css'
import VueLazyload from 'vue-lazyload'
import '/@/styles/iconfont/iconfont.css'
import pinia from './store/pinia'

const app = createInstance(App)

app.use(store, storeKey)
app.use(router)
app.use(initIcons)
app.use(CommonComponents)
app.use(antComponents)
app.use(pinia)

app.use(cookies) // 修改使用方式
app.component('svgIcon', svgIcon)
app.use(useDirectives)
app.use(VueLazyload)

app.config.globalProperties.$cookies = cookies

app.mount('#uav-app')
